import React from 'react';

/**
 * Salty wordmark + "| Control Tower" inline label.
 * variant: "orange" | "cream" | "black"
 * height: logo image height in px
 * showWordmark: show the "| Control Tower" suffix
 * collapsed: sidebar icon-only mode (just the wordmark, no suffix)
 */
export default function SaltyLogo({ height = 32, variant = 'orange', showWordmark = true, collapsed = false }) {
  const src =
    variant === 'cream' ? '/salty-logo-cream.svg' :
    variant === 'black' ? '/salty-logo-black.svg'  :
                          '/salty-logo-orange.svg';

  const dividerColor =
    variant === 'cream' ? 'rgba(255,255,255,0.3)' : '#cbd5e1';

  const labelColor =
    variant === 'cream' ? 'rgba(255,255,255,0.55)' : '#64748b';

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <img
        src={src}
        alt="Salty"
        style={{ height, width: 'auto', display: 'block', flexShrink: 0 }}
      />
      {showWordmark && !collapsed && (
        <>
          <span style={{ color: dividerColor, fontSize: height * 0.7, lineHeight: 1, fontWeight: 300 }}>|</span>
          <span style={{
            fontSize: Math.max(11, height * 0.38),
            fontWeight: 600,
            color: labelColor,
            whiteSpace: 'nowrap',
            letterSpacing: '0.01em',
          }}>
            Control Tower
          </span>
        </>
      )}
    </div>
  );
}
